export default {
  path: 'expenses/:id',
  name: 'Expense',
  component: () => import(/* webpackChunkName: "administration" */ '../views/Expense.vue')
}
